import { render, staticRenderFns } from "./ParcialExamen.vue?vue&type=template&id=0f9a06f7&scoped=true"
import script from "./ParcialExamen.vue?vue&type=script&lang=js"
export * from "./ParcialExamen.vue?vue&type=script&lang=js"
import style0 from "./ParcialExamen.vue?vue&type=style&index=0&id=0f9a06f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a06f7",
  null
  
)

export default component.exports